import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://deepcontrol.co.uk';
const DEFAULT_OG_IMAGE = `${SITE_URL}/images/deep-control-van-canary-wharf.jpg`;
const DEFAULT_TITLE = 'Deep Control | Air Conditioning & HVAC Installation London';
const DEFAULT_DESCRIPTION = 'Premium air conditioning and HVAC installation across London — F-Gas certified, REFCOM compliant, 24/7 emergency call-outs. Get an instant AI-powered quote in 60 seconds.';

/**
 * Per-page SEO head tags.
 * Drop <SEO ... /> inside any route to override the defaults.
 */
const SEO = ({
  title,
  description,
  path = '/',
  image,
  type = 'website',
  noindex = false,
  jsonLd,
}) => {
  const fullTitle = title ? `${title} | Deep Control HVAC London` : DEFAULT_TITLE;
  const fullDescription = description || DEFAULT_DESCRIPTION;
  const fullUrl = `${SITE_URL}${path}`;
  const fullImage = image || DEFAULT_OG_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      <link rel="canonical" href={fullUrl} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="Deep Control" />
      <meta property="og:locale" content="en_GB" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={fullImage} />

      {/* Optional structured data */}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
